/** NHL conference names. */
export class Conferences {
  static Eastern = 'Eastern';
  static Western = 'Western';
}
